import { GET_MEMBERS_LIST } from "../apiRoutes";
import { getDataINSTANCE } from "../controller";

export const getMembersList = async (pageNo, pageSize, userId, workspaceId, subworkspaceId, search) => {
    const data = await getDataINSTANCE(`${GET_MEMBERS_LIST}?pageNo=${pageNo}&pageSize=${pageSize}&userId=${userId}&workspaceId=${workspaceId}&subworkspaceId=${subworkspaceId}&search=${search}`);
    return data;
};
